/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
let isTemporarilyDisabled = false;

const handleOtpCode = async (event, customerEmail) => {
    event.preventDefault();
    document.getElementById('verify-otp-code').disabled = true;

    const errorElement = document.querySelector('.otp-code-error-banner.hidden');
    const errorClass = '.otp-code-error-banner';
    if (!errorElement) {
        hideError(errorClass);
    }

    const otpCode = document.getElementById('otpCodeId').value;
    try {
        toggleLoadingBtn('otp-code');
        
        const response = await fetch(!customerEmail ? `${PROXY}/otp/verify` : `${PROXY}/otp/verify/customer-logged-in`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            // phoneNumber variable is from verify-customer-id file
            body: JSON.stringify({ otpCode, uuid: sessionStorage.getItem('otp-uuid'), customerEmail}),
        });

        if (!response.ok) {
            throw new Error('somethingWrong');
        }

        const jsonResponse = await response.json();
        if (!jsonResponse.success) {
            throw new Error('somethingWrong');
        }

        if (jsonResponse.redirectUrl) {
            window.location.replace(jsonResponse.redirectUrl);
        } else {
            handleNoRedirectUrl(customerEmail);
        }
    } catch (error) {
        console.error('error:', error);
        showError(errorClass, error.message);
    } finally {
        toggleLoadingBtn('otp-code');
        document.getElementById('verify-otp-code').disabled = false;
    }
};

const sendCodeAgain = async () => {
    if (isTemporarilyDisabled) {
        return;
    }
    tempDisableCodeRequest();
    isTemporarilyDisabled = true;
    return new Promise((resolve) => {
        grecaptcha.ready(async () => {
            try {
                const captchaToken = await grecaptcha.execute('6LfQlyAqAAAAAEoCCRS81zjJuBwkoBNghyXp4_kA', { action: 'OTP_RESEND' });
                const response = await fetch(`${PROXY}/otp/resend`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ uuid: sessionStorage.getItem('otp-uuid'), captchaToken }),
                });
                const jsonResponse = await response.json();
                resolve(jsonResponse);
            } catch (error) {
                console.log('error', error);
                showError(errorClass, 'somethingWrong');
                resolve();
            }
        });
    });
};

function handleNoRedirectUrl(customerEmail) {
    if(customerEmail) {
        closeOtpLoginPopup('otp-code');
        return;
    }
    openOtpLoginPopup(null, 'shopify-register');
    closeOtpLoginPopup('otp-code', true);
}

function tempDisableCodeRequest() {
    const container = document.querySelector('[popup-type="otp-code"] .image-with-text__content');
    const sendAgainElement = container.querySelector('.send-code-again-link');
    const timerMessageElement = container.querySelector('.timer-message');
    sendAgainElement.style.display = 'none';
    const DELAY = 30;
    const timerElement = timerMessageElement.querySelector('.timer');
    timerElement.textContent = ('' + DELAY).padStart(2, '0');
    timerMessageElement.classList.remove('hidden');
    const timer = getTimer(DELAY, (sec) => {
        timerElement.textContent = ('' + sec).padStart(2, '0');
    });
    timer();

    setTimeout(() => {
        sendAgainElement.style.display = '';
        isTemporarilyDisabled = false;
        timerMessageElement.classList.add('hidden');
    }, DELAY * 1000);
}

function getTimer(seconds, cb) {
    const requestAnimFrame = (function () {
        return (
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            function (callback) {
                window.setTimeout(callback, 1000 / 60);
            }
        );
    })();

    let _seconds = seconds;
    let lastTime = new Date().getTime();
    let currentTime = new Date().getTime();

    function _timer() {
        if (_seconds == 0) {
            return;
        }
        requestAnimFrame(_timer);
        currentTime = new Date().getTime();

        if (currentTime - lastTime >= 1000) {
            lastTime = currentTime;
            _seconds--;
            cb(_seconds);
        }
    }

    return _timer;
}
